import { FaArrowRight } from "react-icons/fa6";

const Button = ({ text, onClick, className = "" }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`group flex items-center gap-3 pl-6 pr-2 py-1.5 rounded-lg text-white transform-gpu font-semibold bg-primaryAccent transition-all duration-300 hover:bg-primaryAccentHover hover:shadow-lg active:scale-[0.97]  ${className}`}
    >
      {text}

      <span className="bg-[#082344] p-3 rounded-lg group-hover:translate-x-1 transition-all">
        <FaArrowRight size={14} />
      </span>
    </button>
  );
};

export default Button;